import { DEFAULT_SLOT_LIST_LIMIT } from 'constants/common'
import { createContext, useEffect, useState } from 'react'
import { getCurrentZonnedTime } from 'utils/common'

const initialValue = {
  // Used for pagination component
  startSlotDate: null,
  setStartSlotDate: null,
  slotListLimit: DEFAULT_SLOT_LIST_LIMIT,
  setSlotListLimit: null,
}

export const slotDate = (
  timeZone: string,
  initialSlotListLimit?: number
): SlotDateType => {
  const [startSlotDate, setStartSlotDate] = useState<Date | null>(
    initialValue.startSlotDate
  )
  const [slotListLimit, setSlotListLimit] = useState<number>(
    initialSlotListLimit || initialValue.slotListLimit
  )

  useEffect(() => {
    setStartSlotDate(getCurrentZonnedTime(timeZone))
  }, [timeZone])

  // Sync the limit when it resolves asynchronously (useState only captures first render)
  useEffect(() => {
    if (initialSlotListLimit !== undefined) {
      setSlotListLimit(initialSlotListLimit)
    }
  }, [initialSlotListLimit])

  return {
    startSlotDate,
    slotListLimit,
    setStartSlotDate,
    setSlotListLimit,
  }
}

const SlotDateContext = createContext(initialValue)
export default SlotDateContext
